// src/components/runs/RunsStats.jsx
import React from 'react';
import {
  Activity,
  PlayCircle,
  CheckCircle2,
  CalendarDays,
} from 'lucide-react';
import { useTheme } from '../../theme/ThemeContext';

const RunsStats = ({
  totalRuns,
  scheduledRuns,
  inProgressRuns,
  completedRuns,
}) => {
  const { theme } = useTheme();

  // Safe color helpers (fallbacks in case keys don't exist)
  const primary500 = theme?.primary?.[500] || '#0f172a';
  const secondary500 = theme?.secondary?.[500] || '#4f46e5';
  const primary400 = theme?.primary?.[400] || '#1f2937';
  const secondary400 = theme?.secondary?.[400] || '#6366f1';

  const cards = [
    {
      label: 'Total Runs',
      value: totalRuns,
      icon: CalendarDays,
      color: primary500,
    },
    {
      label: 'Scheduled',
      value: scheduledRuns,
      icon: Activity,
      color: secondary500,
    },
    {
      label: 'In Progress',
      value: inProgressRuns,
      icon: PlayCircle,
      color: primary400,
    },
    {
      label: 'Completed',
      value: completedRuns,
      icon: CheckCircle2,
      color: secondary400,
    },
  ];

  return (
    <section className="mb-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
      {cards.map((card) => {
        const Icon = card.icon;
        return (
          <div
            key={card.label}
            className="rounded-2xl bg-white p-5 shadow-sm border border-slate-200 transition-all hover:shadow-md"
          >
            <div className="flex items-center justify-between">
              <div>
                <p className="text-xs font-medium uppercase tracking-wide text-slate-500">
                  {card.label}
                </p>
                <p className="mt-2 text-2xl font-bold text-slate-800">
                  {card.value}
                </p>
              </div>

              <div
                className="flex h-12 w-12 items-center justify-center rounded-xl shadow-inner"
                style={{
                  backgroundColor: `${card.color}22`, // soft tinted background
                }}
              >
                <Icon
                  className="h-6 w-6"
                  style={{ color: card.color }}
                />
              </div>
            </div>
          </div>
        );
      })}
    </section>
  );
};

export default RunsStats;
